document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(location.search);
  const drinkCountService = ['la-coupe-welcome-toast-table','olouioo-signature-coupe-tower-setup-upgrade'].includes(params.get('service_handle')) || /^(La Coupe|Olouioo Signature Coupe Tower)/i.test(params.get('service') || '');
  if (drinkCountService && params.get('guest_tier')) {
    if (!params.get('drink_count')) params.set('drink_count',params.get('guest_tier').replace(/\bguests?\b/gi,'drinks'));
    params.delete('guest_tier');
  }
  for (const key of ['drinks', 'drink']) {
    if (params.get(key)?.startsWith('All three')) params.set(key, 'All three drink types included');
  }
  const keys = ['service','hire_duration','guest_tier','drink_count','finish','linen','drinks','drink','topping','garnish','quantity','date','time','venue','setup','address','suburb','postcode','refreshment','water_style','water_guests','station_drinks','station_garnish','station_topping','station_servings'];
  const selected = keys.filter(key => params.get(key)).map(key => [key,params.get(key)]);
  if (!selected.length) return;
  const section = document.querySelector('[data-selected-enquiry]');
  if (!section) return;
  document.querySelector('#olouioo-quote')?.setAttribute('hidden','');
  section.hidden = false;
  const drinksLabel = document.querySelector('script[data-drinks-count-label]')?.dataset.drinksCountLabel || 'Number of drinks';
  const labels = {service:'Service',hire_duration:'Hire duration',guest_tier:'Guest tier',drink_count:drinksLabel,finish:'Drinkware',linen:'Linen colour',drinks:'Drinks',drink:'Drink',topping:'Topping',garnish:'Garnish',quantity:'Quantity',date:'Date',time:'Start time',venue:'Venue',setup:'Setup',address:'Address',suburb:'Suburb',postcode:'Postcode'};
  const botanicalLabels = document.querySelector('script[data-botanical-enquiry-labels]');
  if (botanicalLabels) Object.assign(labels, JSON.parse(botanicalLabels.textContent));
  if (drinkCountService) {
    const field = section.querySelector('[data-selected-guests]');
    const label = field?.closest('label');
    if (field) field.name = `contact[${drinksLabel}]`;
    if (label) {
      const text = [...label.childNodes].find(node => node.nodeType === 3 && node.textContent.trim());
      if (text) text.textContent = drinksLabel + ' ';
    }
  }
  selected.forEach(([key,value]) => {
    const item = document.createElement('li');
    item.textContent = labels[key] + ': ' + value;
    section.querySelector('[data-selected-list]')?.append(item);
  });
  section.querySelector('[data-selected-options]').value = selected.map(([key,value]) => labels[key]+': '+value).join(' | ');
  if (params.get('date')) section.querySelector('[data-selected-date]').value = params.get('date');
  if (params.get('venue')) section.querySelector('[data-selected-venue]').value = params.get('venue');
  const countValue = params.get(drinkCountService ? 'drink_count' : 'guest_tier');
  if (countValue) {
    const count = countValue.match(/\d+/)?.[0];
    if (count && !countValue.startsWith('More than')) section.querySelector('[data-selected-guests]').value = count;
  }
});


